<div class="hunch-loader-container">
    <ng-lottie [options]="defaultLoading" [height]="height+'px'" [width]="width+'px'"></ng-lottie>
</div>
